import * as React from "react";

const Back = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={91.424}
    height={35.706}
    viewBox="0 0 90.924 35.706"
    {...props}
  >
    <g
      data-name="Icon feather-arrow-down"
      fill="none"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path data-name="Trazado 4" d="M68.127 24.016H0.49" />
      <path
        data-name="Trazado 5"
        d="M12.193 34.308 0.492 24.016 12.193 13.723"
      />
    </g>
    <text
      data-name="Back"
      transform="translate(55.924 17)"
      fill="black"
      fontSize={20}
      fontFamily="CutiveMono-Regular, Cutive Mono"
      letterSpacing=".347em"
    >
      <tspan x={-34.629} y={0}>
        {"Back"}
      </tspan>
    </text>
  </svg>
);

export default Back;
